import React, { useContext, useEffect, useMemo, useState } from "react";
import {
    useReactTable,
    getCoreRowModel,
    flexRender,
    createColumnHelper,
} from "@tanstack/react-table";
import { FilterContext } from "../../context/Filter";
import { fetchamcNonValidContTable } from "./apiInsights";

const Amcnonvalidtable = () => {
    const [amcnonValidContTable, setAmcnonValidContTable] = useState([]);
    const { superArn: parArn, childArn } = useContext(FilterContext);

    const key = childArn ? "childArn" : "parArn";
    const value = childArn || parArn;
    const payload = { [key]: value };

    const getamcNonValidContTable = async () => {
        try {
            // console.log("🚀 Fetching AMC Non-Valid Table:", payload);
            const res = await fetchamcNonValidContTable(payload);
            // console.log("✅ Response:", res);
            setAmcnonValidContTable(res?.data || []);
        } catch (error) {
            console.error("❌ Error fetching AMC Non-Valid Table:", error);
        }
    };

    useEffect(() => {
        getamcNonValidContTable();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const columnHelper = createColumnHelper();

    const columns = useMemo(
        () => [
            columnHelper.accessor("index", {
                header: "#",
                cell: (info) => info.getValue() || "-",
            }),
            columnHelper.accessor("assetNumber", {
                header: "Asset No.",
                cell: (info) => info.getValue() || "-",
            }),
            columnHelper.accessor("registrationNumber", {
                header: "Reg. No.",
                cell: (info) => info.getValue() || "-",
            }),
            columnHelper.accessor("amcEndDate", {
                header: "AMC End Date",
                cell: (info) => info.getValue() || "-",
            }),
            columnHelper.accessor("amcNumber", {
                header: "AMC No.",
                cell: (info) => info.getValue() || "-",
            }),
        ],
        [columnHelper]
    );

    const table = useReactTable({
        data: amcnonValidContTable,
        columns,
        getCoreRowModel: getCoreRowModel(),
    });

    return (
        <div className="p-5 bg-white shadow-lg rounded-xl w-full max-w-5xl mx-auto border border-gray-200">
            <h2 className="text-lg font-semibold mb-4 text-gray-800 text-center">
                AMC Non-Valid Contract Table
            </h2>

            <div className="overflow-x-auto overflow-y-auto max-h-[350px] rounded-lg border border-gray-300">
                <table className="min-w-full border-collapse text-sm">
                    <thead className="bg-[#267CB8] text-white sticky top-0 z-10">
                        {table.getHeaderGroups().map((headerGroup) => (
                            <tr key={headerGroup.id}>
                                {headerGroup.headers.map((header) => (
                                    <th
                                        key={header.id}
                                        className="px-4 py-2 border border-blue-500 text-center font-medium tracking-wide"
                                    >
                                        {flexRender(
                                            header.column.columnDef.header,
                                            header.getContext()
                                        )}
                                    </th>
                                ))}
                            </tr>
                        ))}
                    </thead>

                    <tbody>
                        {table.getRowModel().rows.length > 0 ? (
                            table.getRowModel().rows.map((row, i) => (
                                <tr
                                    key={row.id}
                                    className={`${i % 2 === 0 ? "bg-gray-50" : "bg-white"
                                        } hover:bg-blue-50 transition-colors duration-150`}
                                >
                                    {row.getVisibleCells().map((cell) => (
                                        <td
                                            key={cell.id}
                                            className="px-4 py-2 border border-gray-200 text-center text-gray-700"
                                        >
                                            {flexRender(
                                                cell.column.columnDef.cell,
                                                cell.getContext()
                                            )}
                                        </td>
                                    ))}
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td
                                    colSpan={columns.length}
                                    className="text-center text-gray-500 py-6 border border-gray-200"
                                >
                                    No data available
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default Amcnonvalidtable;
